import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { RouterExtService } from "@core/services/routerExtService.service";
import { UtilitiesService } from "./utilities.service";
import { Constants } from "@core/constants/core.constants";
// TODO eventually this should a more full features service that handles page states as part of the redux
// this way when users hit a navigation control element on the screen the expect action will return the
// user to the the navigation as it exactly is to be expected.

@Injectable()
export class NavigationService {
  constructor(
    private routerExt: RouterExtService,
    private router: Router,
  ) {}

  goBack(params: any = null) {
    let previous = this.routerExt.getPreviousUrl();
    previous = previous === undefined ? "" : previous;

    const current = this.routerExt.getCurrentUrl()
      ? this.routerExt.getCurrentUrl()
      : "";

    // Because of how locations is re-routed based on user location, we need to go back 2 pages if the previous url is a locations menu page
    if (previous.includes("locations/menu")) {
      window.history.go(-2);
      return;
    }

    if (
      previous.indexOf("localhost") > -1 ||
      previous.indexOf("whataburger") > -1 ||
      previous.indexOf("whataburgerdigital") > -1
    ) {
      previous = previous === undefined ? "" : previous;
      const current = this.routerExt.getCurrentUrl()
        ? this.routerExt.getCurrentUrl()
        : "";

      if (
        previous.indexOf("localhost") > -1 ||
        previous.indexOf("whataburger") > -1 ||
        previous.indexOf("whataburgerdigital") > -1
      ) {
        if (params !== null) {
          const route = previous.substring(previous.lastIndexOf("/"));
          this.router.navigate([route], { queryParams: params });
        } else if (previous.includes("addressid")) {
          this.router.navigate(["/order-review"], {
            queryParams: UtilitiesService.generateQueryParams(
              [Constants.DELIVERY_ADDRESS_CHANGE],
              [true],
            ),
          });
        } else {
          window.history.back();
        }
      } else if (
        current.indexOf("localhost") > -1 ||
        current.indexOf("whataburger") > -1 ||
        current.indexOf("whataburgerdigital") > -1
      ) {
        window.history.back();
      } else {
        this.router.navigateByUrl("/home");
      }
    }
  }
}
